// extracted by mini-css-extract-plugin
export default {"header":"catalogPage_header__FVJZP","title_block":"catalogPage_title_block__W8Kvf","footer":"catalogPage_footer__+kLNP"};